(function () {

  function initReviews(section) {

    if (!section) {
      return;
    }


    if (section.dataset.hbReviewsInitialized === 'true') {
      return;
    }


    section.dataset.hbReviewsInitialized = 'true';



    /* ========================================================
       SHOW MORE / SHOW LESS
    ======================================================== */

    var grid =
      section.querySelector(
        '[data-hb-review-grid]'
      );


    var toggle =
      section.querySelector(
        '[data-hb-reviews-toggle]'
      );


    if (grid && toggle) {

      var toggleText =
        toggle.querySelector(
          '[data-hb-reviews-toggle-text]'
        );


      var showMore =
        toggle.getAttribute(
          'data-show-more'
        ) || 'Show more reviews';


      var showLess =
        toggle.getAttribute(
          'data-show-less'
        ) || 'Show less';


      toggle.addEventListener(
        'click',
        function () {

          var expanded =
            grid.classList.toggle(
              'is-expanded'
            );


          toggle.setAttribute(
            'aria-expanded',
            expanded
              ? 'true'
              : 'false'
          );


          if (toggleText) {

            toggleText.textContent =
              expanded
                ? showLess
                : showMore;

          }


          if (!expanded) {

            grid.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });

          }

        }
      );

    }



    /* ========================================================
       CAROUSEL
    ======================================================== */

    var carousel =
      section.querySelector(
        '[data-hb-review-carousel]'
      );


    if (!carousel) {
      return;
    }


    var track =
      carousel.querySelector(
        '[data-hb-review-track]'
      );


    var slides =
      Array.prototype.slice.call(
        carousel.querySelectorAll(
          '[data-hb-review-slide]'
        )
      );


    var prev =
      carousel.querySelector(
        '[data-hb-review-prev]'
      );


    var next =
      carousel.querySelector(
        '[data-hb-review-next]'
      );


    var dotsContainer =
      section.querySelector(
        '[data-hb-review-dots]'
      );


    if (!track || !slides.length) {
      return;
    }



    function getScrollAmount() {

      var firstSlide =
        slides[0];


      if (!firstSlide) {
        return track.clientWidth;
      }


      var styles =
        window.getComputedStyle(
          track
        );


      var gap =
        parseFloat(
          styles.columnGap ||
          styles.gap ||
          0
        );


      return (
        firstSlide.getBoundingClientRect().width
        +
        gap
      );

    }



    function goNext() {

      var maxScroll =
        track.scrollWidth
        -
        track.clientWidth;


      if (
        track.scrollLeft
        >=
        maxScroll - 10
      ) {

        track.scrollTo({
          left: 0,
          behavior: 'smooth'
        });

        return;
      }


      track.scrollBy({
        left: getScrollAmount(),
        behavior: 'smooth'
      });

    }



    function goPrev() {

      if (track.scrollLeft <= 10) {

        track.scrollTo({
          left:
            track.scrollWidth
            -
            track.clientWidth,

          behavior: 'smooth'
        });

        return;
      }


      track.scrollBy({
        left: -getScrollAmount(),
        behavior: 'smooth'
      });

    }



    if (next) {

      next.addEventListener(
        'click',
        goNext
      );

    }


    if (prev) {

      prev.addEventListener(
        'click',
        goPrev
      );

    }



    /* ========================================================
       DOTS
    ======================================================== */

    var dots = [];


    if (dotsContainer) {

      slides.forEach(
        function (slide, index) {

          var dot =
            document.createElement(
              'button'
            );


          dot.type = 'button';

          dot.className =
            'hb-product-reviews__dot';


          dot.setAttribute(
            'aria-label',
            'Go to review ' + (index + 1)
          );


          dot.addEventListener(
            'click',
            function () {

              track.scrollTo({
                left:
                  slide.offsetLeft
                  -
                  track.offsetLeft,

                behavior: 'smooth'
              });

            }
          );


          dotsContainer.appendChild(
            dot
          );


          dots.push(dot);

        }
      );

    }



    function updateDots() {

      if (!dots.length) {
        return;
      }


      var scrollLeft =
        track.scrollLeft;


      var closestIndex = 0;

      var closestDistance =
        Infinity;


      slides.forEach(
        function (slide, index) {

          var distance =
            Math.abs(
              (
                slide.offsetLeft
                -
                track.offsetLeft
              )
              -
              scrollLeft
            );


          if (
            distance
            <
            closestDistance
          ) {

            closestDistance =
              distance;

            closestIndex =
              index;

          }

        }
      );


      dots.forEach(
        function (dot, index) {

          dot.classList.toggle(
            'is-active',
            index === closestIndex
          );

        }
      );

    }



    track.addEventListener(
      'scroll',
      function () {

        window.requestAnimationFrame(
          updateDots
        );

      },
      {
        passive: true
      }
    );


    updateDots();



    /* ========================================================
       AUTOPLAY
    ======================================================== */

    var autoplay =
      section.getAttribute(
        'data-autoplay'
      ) === 'true';


    var delay =
      parseInt(
        section.getAttribute(
          'data-autoplay-delay'
        ),
        10
      ) || 5000;


    var autoplayTimer = null;


    function startAutoplay() {

      if (!autoplay) {
        return;
      }


      stopAutoplay();


      autoplayTimer =
        window.setInterval(
          goNext,
          delay
        );

    }


    function stopAutoplay() {

      if (autoplayTimer) {

        window.clearInterval(
          autoplayTimer
        );

        autoplayTimer = null;

      }

    }



    carousel.addEventListener(
      'mouseenter',
      stopAutoplay
    );


    carousel.addEventListener(
      'mouseleave',
      startAutoplay
    );


    carousel.addEventListener(
      'focusin',
      stopAutoplay
    );


    carousel.addEventListener(
      'focusout',
      startAutoplay
    );


    startAutoplay();

  }



  /* ==========================================================
     INITIAL LOAD
  ========================================================== */

  function initAllReviews(root) {

    var scope =
      root || document;


    var sections =
      scope.querySelectorAll
        ? scope.querySelectorAll(
            '[data-hb-product-reviews]'
          )
        : [];


    sections.forEach(
      function (section) {

        initReviews(section);

      }
    );

  }



  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        initAllReviews(
          document
        );

      }
    );

  } else {

    initAllReviews(
      document
    );

  }



  /* Shopify Theme Editor */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initAllReviews(
        event.target
      );

    }
  );

})();